import { AuthenticationProvider } from './auth/AuthenticationContext';
import { PlansProvider } from './plans/PlansContext';
import { SubscriptionProvider } from './subscription/SubscriptionContext';
import { UsersProvider } from './data/UsersContext';
import { NumbersProvider } from './numbers/NumbersContext';

import { UIProvider } from './ui/UIContext';
import { PageScaffoldProvider } from './ui/PageScaffoldContext';
import { AppProvider } from './data/AppContext';
import { LogsProvider } from './data/LogsContext';
import { ThemeProvider } from './ui/ThemeContext';
import { CompanyProvider } from './company/CompanyContext';

const RootProviders: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <AuthenticationProvider>
      <CompanyProvider>
        <PlansProvider>
          <SubscriptionProvider>
            <UIProvider>
              <ThemeProvider defaultTheme="light">
                <UsersProvider>
                  <NumbersProvider>
                    <PageScaffoldProvider>
                      <LogsProvider>
                        <AppProvider>{children}</AppProvider>
                      </LogsProvider>
                    </PageScaffoldProvider>
                  </NumbersProvider>
                </UsersProvider>
              </ThemeProvider>
            </UIProvider>
          </SubscriptionProvider>
        </PlansProvider>
      </CompanyProvider>
    </AuthenticationProvider>
  );
};

export default RootProviders;
